export default "__VITE_ASSET__vzZzW2FF__"